import { render, staticRenderFns } from "./SoftwareTabs.vue?vue&type=template&id=d8c7c9d8"
import script from "./SoftwareTabs.vue?vue&type=script&lang=js"
export * from "./SoftwareTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports